import { Injectable } from '@angular/core';
import 'rxjs/Rx';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from "app/globals";
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable()
export class ELIAPIService {

    //url: string = `${environment.ELIAPIURL}`;
    url: string = `${environment.ELI_SSO_REDIRECTION}`;

    constructor(
        private httpClient: HttpClient,
        private _Globals: Globals) { }


    //public checkUserSystem(email: string): Observable<{  result: number, message: string, extraData: string  }> {

    //    let url = `${this.url}eli/hubspot/contact?email=${email}`;

    //    console.log('paylod checkUserSystem: ' + url);


    //    let headers = new HttpHeaders()
    //        .set('Content-Type', 'application/json');

    //    return this.httpClient.get<{ result: number, message: string, extraData: string }>(url, { headers: headers });
    //}

    public checkUserAtHubSpot(email: string): Observable<{ Result: number, Message: string, ExtraData: string }> {

        let url = `${this.url}/auth/contacts/check?email=${email}`;

        console.log('paylod checkUserAtHubSpot: ' + url);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');

        return this.httpClient.get<{ Result: number, Message: string, ExtraData: string }>(url, { headers: headers });
    }
}